import * as yup from 'yup'
import { integer, range } from '../../../utils/validation'
import { UNITS } from './constants'
import { COUNTRY } from '../../../utils/constants'

yup.addMethod(yup.mixed, 'integer', integer)
yup.addMethod(yup.mixed, 'range', range)

export const InputSchema = yup.object().shape({
  upliftLoadASD: yup.mixed().integer('Uplift Load (160)(ASD)').range(0, 64000),
  downloadASD: yup.mixed().integer('Download (100)(ASD)').range(0, 64000),
  lateralF1: yup.mixed().when('$country', {
    is: COUNTRY.USA,
    then: (schema) => schema.integer('F1 (160)(ASD)').range(0, 64000),
    otherwise: (schema) => schema.integer('F1').range(0, 64000),
  }),
  lateralF2: yup.mixed().when('$country', {
    is: COUNTRY.USA,
    then: (schema) => schema.integer('F2 (160)(ASD)').range(0, 64000),
    otherwise: (schema) => schema.integer('F2').range(0, 64000),
  }),
  factoredUpliftLRFD: yup.mixed().integer(`Factored Uplift (${UNITS.LSD})`).range(0, 64000),
  factoredDownloadLRFD: yup.mixed().integer(`Factored Download (${UNITS.LSD})`).range(0, 64000),
})
